import createIcon from '../../createIcon';

/**
 * @component @name PermIdentity
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS45QzEzLjE2IDUuOSAxNC4xIDYuODQgMTQuMSA4QzE0LjEgOS4xNiAxMy4xNiAxMC4xIDEyIDEwLjFDMTAuODQgMTAuMSA5LjkgOS4xNiA5LjkgOEM5LjkgNi44NCAxMC44NCA1LjkgMTIgNS45Wk0xMiAxNC45QzE0Ljk3IDE0LjkgMTguMSAxNi4zNiAxOC4xIDE3VjE4LjFINS45VjE3QzUuOSAxNi4zNiA5LjAzIDE0LjkgMTIgMTQuOVpNMTIgNEM5Ljc5IDQgOCA1Ljc5IDggOEM4IDEwLjIxIDkuNzkgMTIgMTIgMTJDMTQuMjEgMTIgMTYgMTAuMjEgMTYgOEMxNiA1Ljc5IDE0LjIxIDQgMTIgNFpNMTIgMTNDOS4zMyAxMyA0IDE0LjM0IDQgMTdWMjBIMjBWMTdDMjAgMTQuMzQgMTQuNjcgMTMgMTIgMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PermIdentity = createIcon('PermIdentity', [
  [
    'path',
    {
      d: 'M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z',
      key: 'lytzey',
    },
  ],
]);

export default PermIdentity;
